import { createSlice } from "@reduxjs/toolkit";
import { systemPayReducer } from "../extraReducers/systemPayReducer";

// 定义初始化数据
const initialState = {
  redEnvelopeList: {} as any,
  redEnvelopeDetail: {} as any,
  privateRedEnvelope: {} as any,
  transferMoneyRecord: {} as any,
};

const systemPaySlice = createSlice({
  name: "paySetting",
  initialState,
  reducers: {},
  extraReducers: systemPayReducer,
});

// 默认导出,到处的文件需要在store入口文件引入
export default systemPaySlice.reducer;
